import { SearchableVendorTaxonomyKey } from '@zola-helpers/client/dist/es/marketplace/vendorTaxonomyKeys';

import queryString, { StringifiableRecord } from 'query-string';

/**
 * The landing page for vendor search.
 *
 * This used to be feature flagged and we controlled the landing via this constant.
 */
export const VENDOR_SEARCH_LANDING_PAGE_URL = '/wedding-vendors';

/**
 * Generates a URL for the vendor category landing page
 */
export const vendorCategoryLandingUrl = (
  vendorTaxonomyKey: SearchableVendorTaxonomyKey
): string => {
  return `${VENDOR_SEARCH_LANDING_PAGE_URL}/${vendorTaxonomyKey}`;
};

/**
 * Generates a URL to search for vendors
 *
 * @param {*} vendorTaxonomyKey - Which vendor is searched
 * @param {*} selectedLocationSlug - Where is the search, this is more important for SEO so it comes first in the generated url
 * @param {*} otherSlugs - Any additional slugs, separated by -- to include. Use for filters.
 * @param {*} queryString - Query string to include in the URL.  Used for filters like price or availability.
 *
 * @returns URL to a vendor search page
 */
export const vendorSearchUrl = (
  vendorTaxonomyKey: SearchableVendorTaxonomyKey | null = null,
  selectedLocationSlug: string | null = null,
  otherSlugs: string[] = [],
  query?: StringifiableRecord
): string => {
  const parts = [selectedLocationSlug, vendorTaxonomyKey, ...otherSlugs];
  // The all-locations is historical and can probably be removed
  const slugs = parts.filter((part) => !!part && part !== 'all-locations').join('--');

  const paths = ['wedding-vendors', 'search', slugs].filter((part) => !!part);
  const url = `/${paths.join('/')}`;

  return queryString.stringifyUrl({ url, query });
};

export default vendorSearchUrl;
